<template>
    <v-card class="mx-auto" max-width="700">
        <v-toolbar color="blue" dark>
            <v-toolbar-title><v-icon>sort</v-icon> Ordenar Pagos</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="fuSave" :loading="dIsLoading"><v-icon left>save</v-icon> Guardar Cambios</v-btn>
        </v-toolbar>
        <v-list two-line>
            <v-list-item-group active-class="blue--text" multiple>
                <draggable v-model="dVsColeProyCuota" tag="div" @start="drag = true" @end="drag = false">
                    <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                        <v-list-item v-for="(item, index) in dVsColeProyCuota"  :key="item.nrocuota">
                            <v-list-item-icon><v-icon color="indigo">drag_indicator</v-icon></v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>
                                    <span class="font-weight-bold mr-2">S/. {{ item.saldo }}</span>
                                </v-list-item-title>
                                <v-list-item-subtitle class="text--primary" v-text="item.glosa"></v-list-item-subtitle>
                                <v-list-item-subtitle>
                                    <v-chip :color="fuColor12Fecha(item.fven)" outlined>{{ fuMesNombreFecha(item.fven) }}</v-chip>
                                </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-action>
                                <v-list-item-action-text v-text="item.fven.substring(0,10)"></v-list-item-action-text>
                                <v-icon @click="fuCopy(item.codcli)" :title="item.codcli" color="grey lighten-1">access_time_filled</v-icon>
                            </v-list-item-action>                            
                        </v-list-item>
                    </transition-group>
                </draggable>
            </v-list-item-group>
        </v-list>
    </v-card>
</template>
<script>
import moment from 'moment';
import gql from 'graphql-tag';
import draggable from 'vuedraggable';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import {fuColor12Fecha, fuMesNombreFecha, fuCopy} from '@/helpers/index.js';

export default {
    name: 'CResumenPago',
    components: {draggable,},
    props: ['pCodigo'],
    mounted(){
    	this.fuLoad(this.pCodigo);
    },
    data: () => ({
        drag: false,
        dIsLoading: false,
        dVsColeProyCuota: [],
    }),
    methods: {
        fuColor12Fecha, fuMesNombreFecha, fuCopy,
        async fuLoad(vCodigo){
            this.dIsLoading = true;
            try {
                const response = await this.$apollo.query({
                    query: gql`query load($cdbarra: String!){
                        vscoleproycuota(cdbarra:$cdbarra){
                            codcli
                            glosa
                            fven
                            idproycuota
                            saldo
                            nrocuota
                        }
                    }`,
                    variables: {
                        cdbarra: vCodigo,
                    },
                    fetchPolicy: 'no-cache'
                })
                this.dVsColeProyCuota = response.data.vscoleproycuota;
                console.log(this.dVsColeProyCuota);
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Problema de Conexión.', 'error');
            } finally {
                this.dIsLoading = false;
            }            
        },
        async fuSave(){
            const CIDSPROYCUOTAS = this.dVsColeProyCuota.map(item => item.idproycuota).join(',');

            try {
                this.dIsLoading = true;

                const response = await this.$apollo.mutate({
                    mutation: gql`mutation vscoleproycuota_ordenar($idproycuotas: String!){
                        vscoleproycuota_ordenar(idproycuotas: $idproycuotas){
                            error
                        }
                    }`,
                    variables: {
                        idproycuotas: CIDSPROYCUOTAS,
                    }
                });
                if(response.data){
                    Swal.fire('Correcto', 'Registro correcto', 'success');
                } else {
                    Swal.fire('¡ ERROR !', 'Registro incorrecto', 'error');
                }
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Registro incorrecto.', 'error');
            } finally {
                this.dIsLoading = false;
            }
        },
    }
}
</script>
<style scoped>
/* Estilo para la transición de elementos al reordenar */
.flip-list-move {
    transition: transform 0.5s;
}

/* Estilo para el elemento que se está arrastrando */
.ghost {
    opacity: 0.5;
    background: #c8ebfb;
}
</style>
